import io from 'socket.io-client'

import store from '@/store'
import { API_URL } from './config/consts'
import { IRoom } from '@/models/IRoom'
import { CONNECTION_STATUS } from '@/shared/consts'

const socket = io(API_URL)

socket.on('connect', () => {
  store.commit('setConnectionStatus', CONNECTION_STATUS.CONNECTED)
})

socket.on('disconnect', (reason: string) => {
  if (reason === 'io server disconnect') {
    socket.connect()
  }
  store.commit('setConnectionStatus', CONNECTION_STATUS.RECONNECTING)
})

export const connections = {
  roomUpdates: {
    open: () =>
      socket.on('room_update', (room: IRoom) => {
        if (room) {
          store.commit('updateRoomStudents', room)
        }
      }),
    close: () => socket.removeListener('room_update')
  },
  reservationUpdates: {
    open: () =>
      socket.on('reservation_update', (room: IRoom) => {
        if (room) {
          store.commit('updateRoomReservation', room)
        }
      }),
    close: () => socket.removeListener('reservation_update')
  },
  clientsUpdates: {
    open: () =>
      socket.on('clients_update', (count: number) => {
        store.commit('setClientsCount', count)
      }),
    close: () => socket.removeListener('clients_update')
  }
}
